<template>
  <div class>
    <div class="uploadMethoRadio">
      <tl-radio name="uploadType" label="Manual" id="manualUpload" value="manualUpload" v-model="uploadMethod" />

      <tl-radio name="uploadType" label="Bulk Upload" id="bulkUpload" value="bulkUpload" v-model="uploadMethod" />
    </div>

    <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />

    <div v-if="uploadMethod == 'manualUpload'">
      <search-dropdown name="search" label="Select Employee" v-model="searchText" :employeeData="customEmpList" @getList="searchDataList"
        @empselected="(emp)=>selectedEmp(emp)" />
      <div class="searchsort">
        <!-- <tl-search class="search-width" @change="filterData" :value="formData.selectedEmp" /> -->
      </div>

      <div class="margin-top-20">

        <selected-employee-card v-if="showSelectedEmployee" @click="closeCard">
          <template v-slot:empDetails>
            <span class="input-label">
              <b>{{empName}}</b>
            </span>
            <span class="input-label">{{empId}}</span>
            <span class="input-label">{{empMail}}</span>
            <!-- <span class="input-label">{{joiningDate}}</span>
            <span class="input-label">Last Login : {{lastLogin}}</span>
            <div class="bottom-buttons">
              <button class="export-button" @click="sendPassword">
                <span> Send </span>
              </button>
            </div> -->
          </template>
        </selected-employee-card>
      </div>

      <div class="margin-top-25">
        <section class="filters">
          <div>
            <span class="feild-label">Select Date</span>
            <date-picker class="custom-width" @datevalue="(val)=>formData.selectedDate=val" :value="formData.selectedDate" name="selectedDate"
              :classname="errors.has('selectedDate')" v-validate="'required'" :errormsg="errors.first('selectedDate')" />
          </div>
          <tl-select label="Component" labelText="name" :value="salaryComponent" :options="salaryComponentsList" :reduce="salaryComponent => salaryComponent.name"
            @change="(salaryComponent)=>changeComponent(salaryComponent)" />

          <ul class="search-result" v-if="auto_suggestions && filterEmpData.length">
            <li v-for="(employee,index) in filterEmpData" :key="index">
              <div class="threeColumnGrid" @click="searchSelected(employee)">
                <div class="img-part">
                  <img src="@/assets/user.svg" />
                </div>
                <div class="empDetails">
                  <div class="empName">
                    <label>{{employee.name}}</label>
                  </div>
                  <div class="empcode">
                    <label>{{employee.code}}</label>
                  </div>
                  <div class="empcode">
                    <label>{{employee.email}}</label>
                  </div>
                </div>
                <div class="role">{{employee.role}}</div>
              </div>
            </li>
          </ul>
          <ul class="search-result" v-else-if="auto_suggestions && !filterEmpData.length">
            <li>No data Available</li>
          </ul>
        </section>
      </div>
      <div class="margin-top-25">
        <section class="filters">
          <txt label="Amount" type="text" v-model="formData.amount" name="Amount" v-validate="'required'" @onValueChange="saveAmpunt"
            :classname="errors.has('Amount')" :errormsg="errors.first('Amount')" />
          <div class="upload-section">
            <img src="@/assets/logout-copy-2.svg" class="logout-copy-2" />
            <label for="upload-photo" class="export-button">Upload</label>
            <input type="file" name="photo" id="upload-photo" @change="uploadFile($event.target.files[0])">
          </div>
        </section>
      </div>

      <div class="align-filters">
        <button class="tags-filters" v-show="showTag" v-for="(file,index) in filesArray" :key="index">
          <span>{{file.key}}</span>
          <img src="@/assets/group-6.svg" @click="removeTag(index)" />
        </button>
      </div>
    </div>
    <div v-else>
      <div class="upload">
        <p></p>
        <p>Drag & drop files here</p>
        <p>Or</p>
        <div class="upload-button">
          <img src="@/assets/logout-copy-2_2@2x.png" alt />
          <label for="upload-photo">Browse</label>
          <input type="file" name="photo" id="upload-photo" />
        </div>
        <p></p>
        <p>Format: jpeg,not more than 5mb</p>
      </div>
    </div>

    <bottom-action-container class="placeEnd">
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="back" />
          <btn text="Add FBP Claim" type="primary" @click="addFbpClaim" />
        </btn-grp>
      </template>
    </bottom-action-container>

    <pop-up-message v-if="showSuccessMsg" :message="`FBM claims uploaded.`" btnText="Back To FBM claims Uploads" @back="backToManuallyClaimsPage"></pop-up-message>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import SearchDropdown from "@/components/TlSearchDropdown.vue";
  import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
  import axios from 'axios'
  export default {
    name: "uploadFbpClaims",
    components: {
      SearchDropdown,
      SelectedEmployeeCard
    },
    data() {
      return {
        filesArray: [],
        errmsg: "",
        toast: false,
        salaryComponent: null,
        le_id: "1580822c-764b-11e9-8f9e-2a86e4085a59",
        salaryComponentsList: [],
        uploadMethod: "manualUpload",
        auto_suggestions: false,
        filterType: {
          component: null
        },
        formData: {
          amount: null
        },
        componentOptions: ["JAN", "FEB", "MAR"],
        showSuccessMsg: false,
        showTag: true,
        employeeData: [
          {
            src: "@/assets/user.svg",
            name: "Chetna Garg",
            code: "4589",
            email: "C@gmail.com",
            role: "Developer",
            id: 1
          },
          {
            id: 2,
            src: "@/assets/user.svg",
            name: "Chetna Garg",
            code: "4589",
            email: "C@gmail.com",
            role: "Developer"
          },
          {
            id: 3,
            src: "@/assets/user.svg",
            name: "Chetna Garg",
            code: "4589",
            email: "C@gmail.com",
            role: "Developer"
          },
          {
            id: 4,
            src: "@/assets/user.svg",
            name: "Chetna Garg",
            code: "4589",
            email: "C@gmail.com",
            role: "Developer"
          },
          {
            id: 5,
            src: "@/assets/user.svg",
            name: "Chetna Garg",
            code: "4589",
            email: "C@gmail.com",
            role: "Developer"
          },
          {
            id: 6,
            src: "@/assets/user.svg",
            name: "Chetna Garg",
            code: "4589",
            email: "C@gmail.com",
            role: "Developer"
          }
        ],
        searchText: "",
        selectedEmployee: {},
        uploading: false,
        empName: "",
        empId: "",
        empMail: "",
        customEmpList: [],
        file: '',
        status: true,
        showSelectedEmployee: false
      };
    },
    mounted() {
      //console.log("New component mounted.");
    },
    activated: function () {
      this.fetchSalaryComponents();
    },
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);

      //return "1580822c-764b-11e9-8f9e-2a86e4085a59";
    },
    methods: {
      ...mapActions({
        act_fetchAllSalaryComponents:
          "onboard/settings/salary_component/fetchAll",
        act_postFbpClaim: "dashboard/payroll/utilities/uploadFbpClaim/create",
        act_fetch_UserList_by_name:
          "dashboard/organisation/utilities/resetPassword/fetchEmpByName"
      }),

      closeCard() {
        this.showSelectedEmployee = false;
        this.searchText = "";
      },

      selectedEmp(emp) {
        //console.log("emp sleected data", emp);
        this.selectedEmployee = emp;
        this.showSelectedEmployee = true;
        this.empName = emp.name;
        this.empId = emp.code;
        this.empMail = emp.email;
        this.joiningDate = emp.joiningDate;
        this.lastLogin = emp.lastLogin;

        this.formData.emp_id = emp.id;
        this.formData.selectedEmp = emp.name;
      },

      async searchDataList(text) {
        //console.log("text", text);
        try {
          let res = await this.act_fetch_UserList_by_name(text);
          if (res.status == 200) {
            //console.log(res.data.payload);
            this.customEmpList = res.data.payload;
            this.customEmpList = [...this.customEmpList];
          }
          //console.log("customEmpList:", this.customEmpList);
        } catch (err) {
          //console.log("err:", err);
          this.errmsg = err.message
            ? err.message
            : err ? err : "Something went wrong";
          this.toast = true;
        }
      },

      async fetchSalaryComponents() {
        try {
          let res = await this.act_fetchAllSalaryComponents(this.le_id);
          //console.log("fetchSalaryComponents:", res);
          let dataArr = res.data.rows;
          if (dataArr.length) {
            this.salaryComponentsList = dataArr;
          }
        } catch (err) {
          //console.log("intro error", err);
          this.toast = true;
          this.errmsg = err.message
            ? err.message
            : err ? err : "Something went wrong";
        }
      },
      changeComponent(salaryComponent) {
        //console.log("changeComponent:", salaryComponent);
        this.formData.componentId = salaryComponent.id;
      },
      saveAmpunt() { },

      backToManuallyClaimsPage() {
        this.showSuccessMsg = false;
      },
      removeTag(index) {
        //this.showTag = false;
        this.filesArray.splice(index, 1);
      },
      uploadFile(uploadFile) {
        if (uploadFile.size > parseInt(this.maxSize)) {
          this.$emit("bigFileSize");
          //console.log("File size too big!");
        }
        else {
          this.uploading = true;
          this.status = false
          this.file = uploadFile
          //console.log('server post', uploadFile)
          axios.post('http://ec2-13-234-115-126.ap-south-1.compute.amazonaws.com:8081/file/upload',
            uploadFile,
            { params: { name: uploadFile.name, type: uploadFile.type } },
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            }
          ).then((res) => {
            //console.log('SUCCESS!!', res);
            this.uploaded = true
            this.uploading = false
            //console.log('status!!', this.status);
            this.$emit('change', res);
            this.filesArray.push(res.data);
            //console.log('filesArray!!', this.filesArray);
          })
            .catch((err) => {
              this.uploading = false
              this.failed = true
              this.status = false
              //console.log('FAILURE!!', err);
              this.toast = true;
              this.errmsg = err.message
                ? err.message
                : err ? err : "Something went wrong";
            })
        }
      },
      searchSelected(employee) {
        //console.log("searchSelected", employee);
        this.formData.emp_id = employee.id;
        this.formData.selectedEmp = employee.name;
        this.auto_suggestions = false;
        //console.log("name", employee.name);
      },
      filterData(searchText) {
        let data = this.$_.cloneDeep(this.employeeData);
        if (searchText.length) {
          this.auto_suggestions = true;
          this.filterEmpData = this.searchData(searchText, this.employeeData);
        } else {
          this.auto_suggestions = false;
        }
      },
      searchData(key, array) {
        const final = [];
        for (let i = 0; i < array.length; i++) {
          let searchObj = array[i].name;
          if (
            searchObj != null &&
            searchObj.toLowerCase().search(key.toLowerCase()) !== -1
          ) {
            final.push(array[i]);
          }
        }
        return final;
      },
      changeDate(val) {
        //console.log("changeDate:", val);
      },

      back() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        });
      },

      addFbpClaim() {

        let billsArr = [];

        for (let index = 0; index < this.filesArray.length; index++) {
          //console.log('fileObj:', this.filesArray[index]);

          billsArr.push(this.filesArray[index].Location);
        }
       

        let obj = {
          emp_id: this.formData.emp_id,
          amount: this.formData.amount,
          bills: billsArr,
          month: this.formData.selectedDate,
          component: this.formData.componentId
        };
        //console.log("addFbpClaim:", obj);
        this.submitForm(obj);
      },

      async submitForm(obj) {
        try {
          let res = await this.act_postFbpClaim(obj);
          //console.log("submitForm:", res);
          if (res.data.statusCode == 200 || res.data.statusCode == 201) {
            this.showSuccessMsg = true;
          }
        } catch (err) {
          //console.log("intro error", err);
          this.toast = true;
          this.errmsg = err.message
            ? err.message
            : err ? err : "Something went wrong";
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .content {
    margin-left: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .subtitle {
    width: 316px;
    height: 15px;
    font-family: Montserrat;
    font-size: 12px;
    color: #646464;
  }

  .searchsort {
    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 10px;
    .sorttext {
      text-align: center;
      line-height: 30px;
      color: #726f75;
      padding: 0px 0px 0px 10px;
      margin-left: auto;
    }
  }

  .uploadMethoRadio {
    display: flex;
    margin-bottom: 2%;
  }

  .month {
    margin-left: 15%;
  }

  .upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient( to right,
    lightgray 10px,
    rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
    background-position: top, right, bottom, left;
    background-repeat: repeat-x, repeat-y;
    background-size: 20px 1px, 1px 20px;
    height: 96%;
    width: 30%;
  }

  .upload-button {
    display: flex;
    align-items: center;
    label {
      cursor: pointer;
      border: 1px solid #5d409f;
      border-radius: 4px;
      padding: 6px 12px;
      font-size: 15px;
      color: #5d409f;
    }
    #upload-photo {
      opacity: 0;
      position: absolute;
      z-index: -1;
    }
    img {
      height: 19px;
      width: 19px;
      margin-right: 8px;
    }
  }

  .align-filters {
    display: flex;
    margin: 30px 0px;
    *:nth-child(1) {
      text-align: center;
    }
    button {
      border-radius: 100px;
      background-color: #b2f8f7;
    }
  }

  .tags-filters {
    width: auto;
    height: 28px;
    display: flex;
    justify-content: space-between;
    margin-left: 10px;
    *:nth-child(1) {
      margin-right: 10px;
      padding-left: 5px;
    }
    img {
      margin-top: 3px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }

  .upload-section {
    margin-left: 6%;
    margin-top: 26px 0px;
    margin: 10px 15px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: flex-end;
  }

  .export-button {
    width: 60px;
    height: 20px;
    border-radius: 4px;
    font-family: Montserrat;
    font-size: 12px;
    text-align: center;
    border: 1px solid #5d409f;
    color: #5d409f;
    margin-left: 3px;
  }

  .search-result {
    position: absolute;
    width: 320px;
    background: #ffffff;
    max-height: 368px;
    border-radius: 4px;
    border: solid 1px #f7f7f7;
    overflow: auto;
    li {
      padding: 15px;
      border-bottom: 0.5px solid #e3e3e3;
      margin-right: 0px !important;
      &:hover {
        background-color: #d6f2f2;
      }
    }
  }

  .threeColumnGrid {
    grid-column-gap: 0px;
  }

  .feild-label {
    font-family: Montserrat;
    font-weight: normal;
    color: #646464;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 5px;
    display: flex;
  }

  .tabs .tab-container {
    padding-top: 30px;
    padding-left: 0px;
  }

  .searchsort {
    .search-width {
      width: 33%;
    }
  }

  .filters {
    grid-template: auto/repeat(6, minmax(180px, 1fr));
  }

  .search-bar {
    height: 35px !important;
  }

  .margin-top-20 {
    margin-top: 2%;
  }

  .margin-top-25 {
    margin-top: 2.5%;
  }

  .margin-top-5 {
    margin-top: 5px;
  }

  .uploadMethoRadio {
    margin-bottom: 3%;
  }

  .tl-select-dropdown {
    margin-bottom: 0px !important;
  }

  .export-button {
    padding: 2px 6.5px;
  }

  .align-filters {
    margin: 30px -10px;
  }

  .datepicker input {
    height: 35px !important;
  }
</style>